// extracted by mini-css-extract-plugin
export default {"tooltip":"TQ-z","arrow":"UQ-z"};